<template>
  <section class="content">
    <ShowBordero v-if="openBordero" :id="id" :close="() => openBordero = false" />
    <div v-if="loading" class="loading-big"><i class="fas fa-spinner loading"></i></div>
    <form v-else class="form" @submit.prevent>
      <div class="row grow">
        <div class="form-group large">
          <form @submit.prevent>
            <label>*Nome</label>
            <div>
              <input
                style="width: 100%"
                ref="field"
                v-model="showName"
                type="text"
                :class="{ error : error.indexOf('name') > -1 }"
                placeholder="Pesquisar evento cadastrado..."
                @focus="focusInput"
                @focusout="closeDrop($event)"
              />
              <div
                v-if="id === 'new'"
                ref="autoList"
                class="auto-list"
                :class="{ show : openDrop }"
                :style="`width: ${$refs.field && $refs.field.clientWidth || 0}px`"
              >
                <div
                  ref="autoListItem"
                  v-for="(item, i) in filteredShows"
                  @click="getShow(item.id)"
                  :key="i"
                  class="auto-list-item"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu o nome do evento</div>

          </form>
        </div>
        <!-- Tipo -->
        <div class="form-group medium">
          <label>*Categoria</label>
          <Autocomplete :model="setShowType" :list="showTypes" placeholder="Ex: Teatro, Cinema, Esportes, ..." :class="{ error : error.indexOf('type') > -1 }" />
          <div v-if="error.indexOf('type') > -1" class="hint">Tipo de evento inválido</div>
        </div>
        <!-- Subcategoria -->
        <div class="form-group medium">
          <label>*Subcategoria</label>
          <Autocomplete :model="setShowType" :list="showTypes" placeholder="Ex: Teatro, Cinema, Esportes, ..." :class="{ error : error.indexOf('type') > -1 }" />
          <div v-if="error.indexOf('type') > -1" class="hint">Tipo de evento inválido</div>
        </div>
        <div
          class="form-group align-end"
          :class="{ 'online-selector' : showOnline }"
        >
          <Selector class="custom-selector" v-model="showOnline" :options="onlineOptions" v-if="id === 'new'"/>
          <span class="text" style="text-transform: initial;font-weight: 500;" v-if="id != 'new'">{{showOnline ? ' Online' : ' Presencial'}}</span>
          <Selector class="custom-selector" v-if="showOnline && id === 'new'" v-model="showLive" :options="liveOptions"/>
          <span class="text" style="text-transform: initial;font-weight: 500;" v-if="id != 'new' && showOnline">{{showOnline && showLive ? 'Ao Vivo' : showOnline ? ' Gravado' : ''}}</span>
        </div>
      </div>
      <div class="row">
        <!-- Produtor -->
        <div class="form-group large">
          <label>* Produtor</label>
          <div style="display: flex; align-items: center;">
            <Autocomplete v-if="!addProducer" :model="setProducer" :list="producers.map(x => `${x.name} (${x.login})`)" placeholder="Nome do produtor" :class="{ error : error.indexOf('producer') > -1 }" style="flex-grow: 1" />
            <input v-if="addProducer" v-model="producerName" type="text" placeholder="Nome do produtor" :class="{ error : error.indexOf('producerName') > -1 }" style="flex-grow: 1" />
            <button @click="newProducer" class="button-form-action" style="margin-left: 10px"><i class="fas" :class="addProducer ? 'fa-times' : 'fa-plus'"></i></button>
          </div>
          <div v-if="error.indexOf('producer') > -1" class="hint">você esqueceu o produtor</div>
          <div v-if="error.indexOf('producerName') > -1" class="hint">você esqueceu o nome do produtor</div>
          <input v-if="addProducer" v-model="producerEmail" type="text" placeholder="E-mail do produtor" :class="{ error : error.indexOf('producerEmail') > -1 || error.indexOf('producer-exists') > -1 }" style="margin-top: 10px" />
          <div v-if="error.indexOf('producerEmail') > -1" class="hint">você esqueceu o e-mail do produtor</div>
          <div v-if="error.indexOf('producer-exists') > -1" class="hint">Já existe um produtor cadastrado com esse e-mail</div>
        </div>
        <div class="form-group">
          <label>*Duração</label>
          <input class="min-number" v-model="showDuration" type="number" min="0" placeholder="Minutos" :class="{ error : error.indexOf('duration') > -1 }" style="max-width: 100px" />
          <div v-if="error.indexOf('duration') > -1" class="hint">você esqueceu a duração</div>
        </div>
        <div class="form-group">
          <label>*Classificação</label>
          <select v-model="showCensor" placeholder="Classificação" :class="{ error : error.indexOf('censor') > -1 }" style="max-width: 150px">
            <option :value="-1">Selecione</option>
            <option :value="0">Livre</option>
            <option :value="10">10</option>
            <option :value="12">12</option>
            <option :value="14">14</option>
            <option :value="16">16</option>
            <option :value="18">18</option>
          </select>
        </div>
        <div class="form-group">
          <label>Classificação Acompanhado</label>
          <select v-model="showCensorFollowed" placeholder="Classificação Acompanhado" :class="{ error : error.indexOf('censorFollowed') > -1 }" style="max-width: 120px">
            <option :value="null">-</option>
            <option :value="0">Livre</option>
            <option :value="10">10</option>
            <option :value="12">12</option>
            <option :value="14">14</option>
            <option :value="16">16</option>
          </select>
        </div>
        <div v-if="showOnline" class="form-group">
          <label>Url</label>
          <input
            v-model="showLiveURL"
            type="text"
            placeholder="https://"
            :class="{ error : error.indexOf('liveUrl') > -1 }" />
          <div v-if="error.indexOf('liveUrl') > -1" class="hint">Ops você esqueceu a URL da midia</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group" style="flex-grow: 1; height: fit-content;">
          <div class="description-header">
            <label>Descrição</label>
            <i @click="fullscreen = !fullscreen" class="fas fa-compress"></i>
          </div>
          <quill-editor v-model="showDescription" :options="editorOption"></quill-editor>
          <!-- <textarea v-model="showDescription" rows="15" placeholder="Descrição do evento" :class="{ error : error.indexOf('description') > -1 }"></textarea> -->
          <div v-if="error.indexOf('description') > -1" class="hint">você esqueceu a descrição do evento</div>
        </div>
      </div>

      <div class="row">
        <div class="form-group" v-if="id === 'new' && !this.showOnline">
          <label class="switch">
            <input v-model="withoutStage" type="checkbox">
            <span class="slider"></span>
            <span class="text">Sem assentos definidos</span>
          </label>
        </div>
        <div class="form-group" v-if="id != 'new' && !this.showOnline">
          <label class="switch">
            <span class="text" style="text-transform: initial;font-weight: 600;">Com assentos definidos</span>
          </label>
        </div>
        <div class="form-group" v-if="!this.showOnline && this.id === 'new' && !withoutStage && sections.length > 0">
          <label class="switch">
            <input v-model="withSection" type="checkbox">
            <span class="slider"></span>
            <span class="text">Venda por setores</span>
          </label>
        </div>
        <div class="form-group" v-if="id != 'new' && withSection">
          <label class="switch">
            <span class="text" style="text-transform: initial;font-weight: 600;">Venda com setores</span>
          </label>
        </div>
        <!--<div class="form-group" v-if="!this.showOnline && !withoutStage">
          <label class="switch">
            <input v-model="distanceRule" type="checkbox">
            <span class="slider"></span>
            <span class="text">Aplicar distânciamento de assentos</span>
          </label>
        </div>-->
      </div>

      <div class="row">
        <div class="columns">
          <div class="column">
            <div class="form-group">
              <label>*Banner</label>
              <div class="show-image" @click="$refs.fileUpload.click()">
                <div class="res" v-if="!image">1000px x 400px</div>
                <img v-else :src="imageFile ? image : `${API_IMG}/${business.id}/${showId}/${image}`">
                <input ref="fileUpload" type="file" accept="image/jpeg" @change="changeImage($event.target.files[0])">
              </div>
              <div v-if="error.indexOf('image') > -1" class="hint" style="font-size:0.8em;color:#880000;margin-top:3px;margin: 0 auto;">você esqueceu a imagem do evento</div>
            </div>
            <div class="form-group">
              <label class="switch">
                <input v-model="showcase" type="checkbox">
                <span class="slider"></span>
                <span class="text">Aparecer na vitrine</span>
              </label>
              <label class="switch">
                <input v-model="privateShow" type="checkbox">
                <span class="slider"></span>
                <span class="text">Privado</span>
              </label>
            </div>
            <div v-if="showOnline && !showLive" class="form-group">
              <label>Disponivel até</label>
              <input v-model="dateDay" type="date" :min="(new Date()).toISOString().split('T')[0]" :class="{ error : error.indexOf('dates') > -1 || error.indexOf('date-' + index) > -1 }" style="flex: 1" />
              <div v-if="error.indexOf('date-' + index) > -1" class="hint">você já cadastrou um evento nessa data</div>
            </div>
            <div v-else class="form-group">
              <label>Datas do evento</label>
              <div v-for="(date, index) in dates" :key="index" style="margin-bottom: 15px">
                <div style="display: flex; align-items: center">
                  <input v-model="date.day" type="date" :min="(new Date()).toISOString().split('T')[0]" :class="{ error : error.indexOf('dates') > -1 || error.indexOf('date-' + index) > -1 }" style="flex: 1" />
                  <input v-model="date.hour " v-mask="'##:##'" type="text" placeholder="__:__" :class="{ error : error.indexOf('dates') > -1 || error.indexOf('date-' + index) > -1 }" style="width: 60px; margin: 0 10px; padding: 10px 8px;" />
                  <button v-if="id === 'new' && dates.length > 1 && index !== dates.length - 1 && id === 'new'" @click="dates.splice(index, 1)" class="button-form-action"><i class="fas fa-times"></i></button>
                  <button v-else-if="dates.length - 1 === index" @click="dates.push({ id: null, day: null, hour: null })" class="button-form-action"><i class="fas fa-plus"></i></button>
                  <div v-else style="margin: 20px"></div>
                </div>
                <div v-if="error.indexOf('date-' + index) > -1" class="hint">você já cadastrou um evento nessa data</div>
              </div>
              <!-- <button @click="dates.push({ day: null, hour: null })" class="button-form" style="margin: 0"><i class="fas fa-plus"></i><span>Nova Data</span></button> -->
              <div v-if="error.indexOf('dates') > -1" class="hint">você esqueceu a data/hora do evento</div>
            </div>
            <div class="form-group">
              <label>Início das vendas</label>
              <div style="display: flex; align-items: center">
                <select v-model="dateSaleDate" style="width: 100px; margin-right: 10px">
                  <option :value="true">Data</option>
                  <option :value="false">Dias antes</option>
                </select>
                <input v-if="dateSaleDate" v-model="dateSale" type="date" :class="{ error : error.indexOf('dateSale') > -1 }" style="flex: 1" />
                <input v-if="!dateSaleDate" v-model="dateSale" type="number" min="1" placeholder="Dias" :class="{ error : error.indexOf('dateSale') > -1 }" style="flex: 1" />
              </div>
            </div>
            <div class="form-group">
              <label v-if="!this.showOnline">Encerramento das vendas (Horas antes)</label>
              <input v-if="!this.showOnline" v-model="dateHourCloseSale" type="number" placeholder="Horas" :class="{ error : error.indexOf('hourCloseSale') > -1 }"  />
              <div v-if="error.indexOf('hourCloseSale') > -1" class="hint">você esqueceu de informar este campo</div>
            </div>
            <div class="form-group">
              <label v-if="!this.showOnline">Máximo de ingressos por cliente</label>
              <input v-if="!this.showOnline" v-model="dateMaxTicketUser" type="number" min="1" placeholder="Número" :class="{ error : error.indexOf('maxTicketUser') > -1 }"  />
              <div v-if="error.indexOf('maxTicketUser') > -1" class="hint">você esqueceu de informar este campo</div>
            </div>
          </div>
          <!-- <div class="divider"></div> -->
          <div class="column" style="max-width: 50%">
            <div class="form-group">
              <label>Parcelamento</label>
              <div class="installments">
                <div v-for="x in [1,2,3,4,5,6,7,8,9,10,11,12]" @click="toggleInstallment(x)" :key="x" class="installment" :class="{ 'active' : installments.includes(x) }">
                  {{ x }}x
                </div>
              </div>
            </div>
            <!-- <div class="form-group" style="margin-bottom: 0px">
              <label v-if="id === 'new'" class="switch" style="margin: 10px 0">
                <input v-model="clientInterest" type="checkbox">
                <span class="slider"></span>
                <span class="text">Juros atrelado ao cliente final</span>
              </label>
              <label v-if="id != 'new'" class="switch" style="margin: 10px 0">
                <span class="text" style="text-transform: initial;font-weight: 600;">{{clientInterest ? 'Juros atrelado ao cliente final' : 'Juros atrelado ao organizador'}}</span>
              </label>
            </div> -->
            <div class="form-group" v-if="!withSection">
              <div class="form-group" style="margin:0">
                <label>Valor do ingresso para calculo</label>
                <money v-model="priceValue"></money>
              </div>

              <label v-if="!showOnline">Tipo de Ingresso</label>
              <div v-if="!showOnline" style="display: flex; align-items: center; margin-bottom: 15px">
                <select v-model="priceType" @change="addType" :class="{ error : error.indexOf('prices') > -1 }" style="flex: 1">
                  <option :value="null">Adicionar tipo de ingresso</option>
                  <option v-for="type in selectTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                </select>
                <!-- <button @click="addType" class="button-form-action" style="margin: 0 15px"><i class="fas fa-plus"></i></button> -->
              </div>
              <div v-if="error.indexOf('prices') > -1" class="hint" style="margin-bottom: 15px">Preços com valores inválidos</div>

              <!-- Preços -->
              <table class="table" v-if="!showOnline">
                <thead>
                  <tr>
                    <th align="left">Tipo</th>
                    <th align="left">Valor</th>
                    <th>Ação</th>
                  </tr>
                </thead>

                <draggable v-model="prices" tag="tbody">
                  <tr v-for="(price, index) in prices" :key="index">
                    <td style="text-transform: capitalize" :class="{ disableprice : price.active === false }">
                      <span @click="ticketDesc = price" :class="{ hasTicketDesc : price.ticketDesc }" style="margin:5px 5px 0 0;font-size:18px;cursor:pointer;"><i class="fas fa-info-circle"></i></span>
                      {{ price.name }}
                    </td>
                    <td v-if="id === 'new' || price.change"><money v-model="price.value" style="width: 100px"></money></td>
                    <td v-else>{{ price.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</td>
                    <td align="center">
                      <button :disabled="id != 'new' && price.amountsold > 0" v-show="id != 'new'" @click="editPrice(price, index)" class="button-form-action" style="margin-left:10px;" :class="id != 'new' && price.amountsold > 0 ? 'lock-btn' : 'unlock-btn'"><i class="fas" :class="price.change ? 'fa-check' : 'fa-pencil-alt'"></i></button>
                      <button :disabled="id != 'new' && price.amountsold > 0" @click="removePrice(price, index)" class="button-form-action" style="margin-left:10px;margin-right:10px;" :class="id != 'new' && price.amountsold > 0 ? 'lock-btn' : 'unlock-btn'"><i class="fas fa-trash-alt"></i></button>
                      <div v-show="id != 'new'" class="form-group" style="margin:auto;display:inline-flex;width:60px;">
                        <label class="switch" style="margin:auto;margin-top:10px;">
                          <input type="checkbox" @click="togglePrice(price, index)" v-model="price.active" :checked="price.active">
                          <span class="slider"></span>
                          <span class="text"></span>
                        </label>
                      </div>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>

            <div class="form-group" v-else>
              <label>Selecione o setor</label>
              <div v-if="!showOnline" style="display: flex;align-items: center;margin-bottom: 15px">
                <select
                  v-model="selectedSection"
                  @change="priceValue = 0"
                  :class="{ error : error.indexOf('prices') > -1 }"
                  style="flex: 1"
                >
                  <option :value="null">Selecione o setor</option>
                  <option v-for="(section, i) in sections" :key="i" :value="section">{{ String(section.name).replace(/_/g," ") }}</option>
                </select>
                <!-- <button @click="addType" class="button-form-action" style="margin: 0 15px"><i class="fas fa-plus"></i></button> -->
              </div>
              <div v-if="error.indexOf('prices') > -1" class="hint" style="margin-bottom: 15px">Preços com valores inválidos</div>

              <div class="section-prices" v-if="selectedSection">
                <!-- Valor para calculo relativo ao setor -->
                <div class="form-group" style="margin: 0; margin-bottom:15px">
                  <label>Valor do ingresso para cálculo</label>
                  <money v-model="priceValue"></money>
                </div>

                <!-- Preços -->
                <select
                  v-model="priceType"
                  @change="addType"
                  :class="{ error : error.indexOf('prices') > -1 }"
                  style="width: 210px
                ">
                  <option :value="null">Adicionar tipo de ingresso</option>
                  <option
                    v-for="type in selectSectionTypes"
                    :key="type.id"
                    :value="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>

                <table class="table">
                  <thead>
                    <tr>
                      <th align="left">Tipo</th>
                      <th align="left">Valor</th>
                      <th>Ação</th>
                    </tr>
                  </thead>

                  <draggable v-model="prices" tag="tbody">
                    <tr
                      v-for="(price, index) in selectedSection.prices"
                      :key="`prices${index}`"
                    >
                      <td style="text-transform: capitalize" :class="{ disableprice : price.active === false }">
                        <span @click="ticketDesc = price" :class="{ hasTicketDesc : price.ticketDesc }" style="margin:5px 5px 0 0;font-size:18px;cursor:pointer;"><i class="fas fa-info-circle"></i></span>
                        {{ price.name }}
                      </td>

                      <td v-if="id === 'new' || price.change">
                        <money
                          v-model="price.value"
                          editable="false"
                          style="width: 100px"
                        ></money>
                      </td>

                      <td v-else>
                        {{
                          price.value.toLocaleString(
                            'pt-br',
                            { style: 'currency', currency: 'BRL' }
                          )
                        }}
                      </td>

                      <td align="center">
                        <button type="button" :disabled="id != 'new' && price.amountsold > 0" v-show="id != 'new'" @click="editPrice(price, index)" class="button-form-action" style="margin-left:10px;" :class="id != 'new' && price.amountsold > 0 ? 'lock-btn' : 'unlock-btn'"><i class="fas" :class="price.change ? 'fa-check' : 'fa-pencil-alt'"></i></button>
                        <button type="button" :disabled="id != 'new' && price.amountsold > 0" @click="removePrice(price, index)" class="button-form-action" style="margin-left:10px;margin-right:10px;" :class="id != 'new' && price.amountsold > 0 ? 'lock-btn' : 'unlock-btn'"><i class="fas fa-trash-alt"></i></button>
                        <div v-show="id != 'new'" class="form-group" style="margin:auto;display:inline-flex;width:60px;">
                          <label class="switch" style="margin:auto;margin-top:10px;">
                            <input type="checkbox" @click="togglePrice(price, index)" v-model="price.active" :checked="price.active">
                            <span class="slider"></span>
                            <span class="text"></span>
                          </label>
                        </div>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button v-if="id !== 'new'" @click="openBordero = true" class="btn-save btn-bordero"><i class="fas fa-file-medical-alt"></i><span>Borderô</span></button>
      <button @click="saveShow" class="btn-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
    </form>
    <TicketTypeDesc v-if="ticketDesc" :ticket="ticketDesc" :showDate="id" :close="() => this.ticketDesc = null" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import Selector from './Selector'
import { getToken } from '../../util'
import {
  get,
  create as createDate,
  update as updateDate,
  // cancel,
  createPrice,
  updatePrice,
  removePrice,
  updatePriceOrder,
  updatePriceAmount
} from '../api/showDate'
import {
  getAll,
  get as getShow,
  create as createShow,
  update as updateShow,
  getPreviousPrice
} from '../api/show'
import { getAll as getTicketTypes } from '../api/ticketType'
import { getAll as getProducers, create as createProducer } from '../api/producer'
import { get as getDefault } from '../api/businessDefault'
import { getAll as getShowTypes } from '../api/showType'
import { get as getUpload } from '../api/showUpload'
import { getAll as getTickets } from '../api/ticket'
import { getAll as getPaymentFees } from '../api/paymentFee'
import { getSections } from '../api/business'

import Autocomplete from './Autocomplete.vue'
import draggable from 'vuedraggable'
import ShowBordero from './ShowBordero.vue'
import TicketTypeDesc from './TicketTypeDesc.vue'

// Quill Editor
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { Quill, quillEditor } from 'vue-quill-editor'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['12px', '14px', '16px', '20px']
Quill.register(sizeStyle, true)

export default {
  name: 'show',
  components: {
    Selector,
    Autocomplete,
    quillEditor,
    draggable,
    ShowBordero,
    TicketTypeDesc
  },
  props: ['id'],
  data () {
    return {
      openDrop: false,
      API: process.env.VUE_APP_API,
      token: getToken(),
      API_IMG: process.env.VUE_APP_IMG,
      dateSale: (new Date()).toISOString().split('T')[0],
      totalWithoutFees: 0,
      totalWithFees: 0,
      showCensor: 0,
      priceValue: 0,
      priceTypeValue: 0,
      dateHourCloseSale: 2,
      tickets: 0,
      numberInstallments: 3,
      dateMaxTicketUser: 5,
      distanceRule: false,
      loading: true,
      showcase: true,
      withSection: false,
      dateLocalSale: false,
      addProducer: false,
      showOnline: false,
      dateSaleDate: true,
      fullscreen: false,
      booking: false,
      withoutStage: false,
      instalmentFee: true,
      clientInterest: true,
      online: false,
      showLive: false,
      fees: null,
      page: null,
      currentSection: null,
      selectedSection: null,
      name: null,
      showId: null,
      showName: '',
      showType: null,
      showDuration: null,
      showCensorFollowed: null,
      showDescription: null,
      image: null,
      imageFile: null,
      priceType: null,
      cancelReason: null,
      dateDay: null,
      dateHour: null,
      producer: null,
      producerName: null,
      producerEmail: null,
      showUpload: null,
      showLiveURL: null,
      sections: [],
      shows: [],
      error: [],
      installments: [1],
      dates: [{ day: null, hour: null }],
      ticketTypes: [],
      prices: [],
      sectionsPrices: [],
      searchShow: '',
      showTypes: [],
      producers: [],
      openBordero: false,
      ticketDesc: null,
      privateShow: false,
      onlineOptions: [
        {
          value: false,
          text: 'PRESENCIAL'
        },
        {
          value: true,
          text: 'ONLINE'
        }
      ],
      instalmentFeeOptions: [
        {
          value: true,
          text: 'COM JUROS*'
        },
        {
          value: false,
          text: 'SEM JUROS'
        }
      ],
      liveOptions: [
        {
          value: false,
          text: 'GRAVADO'
        },
        {
          value: true,
          text: 'LIVE'
        }
      ],
      editorOption: {
        placeholder: 'Descrição do evento',
        modules: {
          toolbar: [
            [{ 'size': ['12px', false, '16px', '20px'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'align': [] }, { 'list': 'bullet' }, { 'list': 'ordered' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image', 'video'],
            ['clean']
          ]
        }
      }
    }
  },
  computed: {
    ...mapState(['business']),
    selectTypes () {
      return this.ticketTypes.filter(x => !this.prices.find(y => y.name === x.name))
    },
    selectSectionTypes () {
      if (!this.selectedSection) return []
      return this.ticketTypes.filter(x => {
        if (this.selectedSection.prices.find(y => y.name === x.name)) return false
        if (x.name.substr(0, 5) === 'Mesa ' && !this.selectedSection.tables.includes(x.name)) return false
        return true
      })
    },
    filteredShows () {
      return this.shows.filter(x => x.name.toUpperCase().includes(this.showName.toUpperCase())).filter((x, i) => i < 5)
    }
  },
  watch: {
    priceValue (value) {
      if (this.id !== 'new') return
      if (this.withSection && this.selectedSection && value !== 0) {
        this.selectedSection.prices.forEach(x => {
          x.value = value * (x.percentage / 100)
        })
      } else if (value) {
        this.prices.forEach(x => {
          x.value = value * (x.percentage / 100)
        })
      }
    },
    async page (value) {
      if (value === 8) {
        try {
          const tickets = await getTickets(this.id)
          this.tickets = tickets.filter(x => x.status === 'paid').length
        } catch (error) {
          logger.error(error, this)
        }
      }
    }
  },
  async mounted () {
    try {
      // Shows
      this.fees = await getPaymentFees()
      this.shows = await getAll()
      this.ticketTypes = await getTicketTypes()
      this.showTypes = (await getShowTypes()).map(x => x.name)
      this.producers = await getProducers()
      // get sections by businessId
      const sections = await getSections(this.business.id)

      // quantity of "meia entrada" for sections
      let qtd = sections.length

      this.sections = sections.map(x => {
        x.prices = this.ticketTypes.filter(x => x.default).map(x => {
          let amount = 0
          if (x.name.toUpperCase().startsWith('MEIA')) amount = Math.ceil((this.business.capacity * 0.4) / qtd)
          else amount = null
          return {
            name: x.name,
            sell: x.sell,
            percentage: x.percentage,
            value: 0,
            special: x.special,
            order: 0,
            amount,
            active: x.active,
            change: false,
            amountsold: x.amountsold,
            ticketDesc: x.ticketDesc
          }
        })
        return x
      })

      // Create
      if (this.id === 'new') {
        this.page = 1
        const defaults = await getDefault()
        this.dateHourCloseSale = defaults.hourCloseSale
        this.dateMaxTicketUser = defaults.maxTicketUser
        this.prices = this.ticketTypes.filter(x => x.default).map(x => {
          let amount = 0
          if (x.name.toUpperCase().startsWith('MEIA')) amount = Math.ceil((this.business.capacity * 0.4))
          else amount = null
          return {
            name: x.name,
            sell: x.sell,
            percentage: x.percentage,
            value: 0,
            special: x.special,
            order: 0,
            amount,
            change: false,
            active: true,
            ticketDesc: x.ticketDesc
          }
        })
      // Update
      } else {
        const data = await get(this.id)
        // Name
        this.name = `${this.getDay(data.showDate.date)}/${this.getMonth(data.showDate.date)} - ${data.show.name}`
        // Show Date
        data.showDate.forEach(x => {
          x.day = this.getDateISO(x.date)
          x.hour = `${this.getHours(x.date)}:${this.getMinutes(x.date)}`
        })
        this.dates = data.showDate
        // this.dateDay = this.getDateISO(data.showDate.date)
        // this.dateHour = `${this.getHours(data.showDate.date)}:${this.getMinutes(data.showDate.date)}`
        this.dateLocalSale = data.showDate[0].localSale
        this.dateSaleDate = true
        this.dateSale = this.getDateISO(data.showDate[0].dateSale)
        this.dateHourCloseSale = data.showDate[0].hourCloseSale
        this.dateMaxTicketUser = data.showDate[0].maxTicketUser
        this.withoutStage = data.showDate[0].withoutStage || false
        this.withSection = data.showDate[0].withSection
        this.clientInterest = data.showPayment.clientInterest
        this.numberInstallments = data.showPayment.installments.length
        this.installments = data.showPayment.installments
        // Show
        this.showId = data.show.id
        this.showName = data.show.name
        this.showType = data.show.type
        const _producer = this.producers.find(x => x.id === data.show.producer)
        if (_producer) this.setProducer(`${_producer.name} (${_producer.login})`)
        this.showDuration = data.show.duration
        this.showCensor = data.show.censor
        this.showCensorFollowed = data.show.censorFollowed
        this.showDescription = data.show.description
        this.showOnline = data.show.online
        this.showLive = data.show.live || false
        this.showcase = data.show.showcaseBusiness
        this.privateShow = data.show.private
        this.showLiveURL = data.show.liveUrl
        this.image = data.show.images ? data.show.images[0] : null
        // Prices
        if (this.withSection) {
          this.sections.forEach(section => {
            section.prices = data.prices.filter(y => section.name === y.section).map(y => ({
              id: y.id,
              name: y.ticketType,
              sell: y.sell,
              value: y.price,
              special: y.special,
              order: y.order || 0,
              amount: y.amount || 0,
              change: false,
              active: y.active,
              amountsold: y.amountsold,
              ticketDesc: y.ticketDesc
            }))
          })
        }
        this.prices = data.prices.map(x => ({
          id: x.id,
          name: x.ticketType,
          sell: x.sell,
          // percentage: 100,
          value: x.price,
          special: x.special,
          order: x.order || 0,
          amount: x.amount || 0,
          active: x.active,
          change: false,
          amountsold: x.amountsold,
          ticketDesc: x.ticketDesc
        }))
        // Show upload
        if (data.show.showUpload) this.showUpload = await getUpload(data.show.showUpload)
        this.page = 0
      }
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    focusInput ($event) {
      if (this.selectList) {
        this.$refs.field.isList = true
        document.addEventListener('mousedown', this.closeDrop)
      }

      $event.target.select()
      this.openDrop = true
    },
    closeDrop (event) {
      if (
        !this.selectList ||
        (event.type !== 'focusout' &&
        !this.$refs.autoListItem.find(x => x === event.target))
      ) {
        setTimeout(() => { this.openDrop = false }, 200)
        document.removeEventListener('mousedown', this.closeDrop)
      }
    },
    addSectionType () {
      const type = this.ticketTypes.find(x => x.id === this.priceType)
      if (type) {
        let amount = 0
        if (type.name.toUpperCase().startsWith('MEIA')) amount = Math.ceil((this.business.capacity * 0.4))
        else amount = null
        this.currentSection.prices.push({
          name: type.name,
          sell: type.sell,
          percentage: type.percentage,
          value: this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
          special: type.special,
          amount,
          ticketDesc: type.ticketDesc
        })
      }
    },
    toggleInstallment (x) {
      if (x === 1) return false
      if (this.installments.includes(x)) {
        this.installments = this.installments.filter(y => y !== x)
      } else {
        this.installments.push(x)
        for (let i = 1; i < x; i++) if (!this.installments.includes(i)) this.installments.push(i)
      }
    },
    async updatePriceOrder () {
      this.loading = true
      try {
        await updatePriceOrder(this.id, this.prices.map((x, i) => ({
          id: x.id,
          order: i
        })))
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = ['prices']
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    setShowType (showType = null) {
      if (showType) {
        this.showType = showType
      } else {
        return this.showType
      }
    },
    newProducer () {
      if (!this.addProducer) {
        // this.producerName = null
        this.producerEmail = null
      }
      this.addProducer = !this.addProducer
    },
    setProducer (name = null) {
      if (name) {
        this.producerName = null
        this.producerEmail = null
        this.producer = this.producers.find(x => name === `${x.name} (${x.login})`) || null
        if (!this.producer) {
          this.producerName = name
        } else {
          this.producerName = null
          this.producerEmail = null
        }
      } else {
        return this.producer ? this.producer.name : ''
      }
    },
    changePage (page) {
      if (this.loading) return false
      this.error = []

      if (page === 3) {
        if (!this.showName) this.error.push('name')
        if (!this.showType) this.error.push('type')
        if (!this.showDuration) this.error.push('duration')
        if (this.showCensor < 0) this.error.push('censor')
        if (this.producerName && !this.producerEmail && !this.producer) this.error.push('producerEmail')
        if (!this.producerName && this.producerEmail && !this.producer) this.error.push('producerName')
        if (!this.producerName && !this.producerEmail && !this.producer) this.error.push('producer')
      } else if (page === 4) {
        if (!this.showDescription) this.error.push('description')
      } else if (page === 6 && !this.showOnline) {
        if (!this.dates[0].day || !this.dates[0].hour) this.error.push('no-date')
      } else if (page === 7) {
        if (!this.dateSale) this.error.push('dateSale')
        if (this.dateMaxTicketUser <= 0) this.error.push('maxTicketUser')
      }

      if (this.error.length === 0) this.page = page
    },
    newShow () {
      this.showId = null
      this.showName = null
      this.showType = null
      this.showProducer = null
      this.showDuration = null
      this.showCensor = 0
      this.showCensorFollowed = null
      this.showDescription = null
      this.showOnline = false
      this.showLive = false
      this.showLiveURL = null
      this.image = null
      this.page = 2
    },
    async addType () {
      this.loading = true
      try {
        if (this.showOnline) {
          this.error = []
          if (this.prices.filter(x => x.sell).length > 0) {
            this.error = ['prices_online']
            return false
          }
          const price = await createPrice(
            this.id,
            1,
            'Online',
            this.priceTypeValue,
            true,
            false
          )
          this.prices.push({
            id: price.id,
            name: 'Online',
            sell: true,
            value: this.priceTypeValue,
            special: false,
            amount: 0,
            active: true,
            change: false
          })
        } else {
          const type = this.ticketTypes.find(x => x.id === this.priceType)
          let amount = 0
          if (type.name.toUpperCase().startsWith('MEIA')) amount = Math.ceil((this.business.capacity * 0.4))
          else amount = null
          if (type) {
            if (this.id !== 'new') {
              if (this.withSection) {
                const price = await createPrice(
                  this.id,
                  this.selectedSection.name,
                  type.name,
                  this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
                  type.sell,
                  type.special,
                  type.TicketDesc
                )

                this.selectedSection.prices.push({
                  id: price.id,
                  name: type.name,
                  sell: type.sell,
                  percentage: type.percentage,
                  value: this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
                  special: type.special,
                  amount,
                  active: true,
                  change: false,
                  ticketDesc: type.ticketDesc
                })
              }
              const price = await createPrice(
                this.id,
                null,
                type.name,
                this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
                type.sell,
                type.special,
                type.ticketDesc
              )
              this.prices.push({
                id: price.id,
                name: type.name,
                sell: type.sell,
                percentage: type.percentage,
                value: this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
                special: type.special,
                amount,
                active: true,
                change: false,
                ticketDesc: type.ticketDesc
              })
            } else {
              if (this.withSection) {
                this.selectedSection.prices.push({
                  name: type.name,
                  sell: type.sell,
                  percentage: type.percentage,
                  value: this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
                  special: type.special,
                  amount,
                  active: true,
                  change: false,
                  ticketDesc: type.ticketDesc
                })
              } else {
                this.prices.push({
                  name: type.name,
                  sell: type.sell,
                  percentage: type.percentage,
                  value: this.priceValue ? this.priceValue * (type.percentage / 100) : 0,
                  special: type.special,
                  amount,
                  active: true,
                  change: false,
                  ticketDesc: type.ticketDesc
                })
              }
            }
          }
        }
        this.priceType = null
        this.priceTypeValue = 0
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = ['prices']
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async togglePrice (price, index) {
      if (this.id !== 'new') {
        this.loading = true
        try {
          await updatePrice(
            price.id,
            this.id,
            price.name,
            price.value,
            price.sell,
            !price.active,
            price.ticketDesc
          )
          this.prices[index].active = !price.active
          // price.sell = !price.sell
        } catch (error) {
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = ['prices']
          } else if (data.error === 'Foreign') {
            this.$message.error('Ingresso não pode ser alterado, pois já foi utilizado!', { duration: 3000 })
          } else {
            logger.error(error, this)
          }
        }
        this.loading = false
      }
    },
    async removePrice (price, index) {
      this.loading = true
      try {
        if (!this.withSection) {
          if (this.id !== 'new') await removePrice(price.id, this.id)
          this.prices.splice(index, 1)
        } else {
          if (this.id !== 'new') await removePrice(price.id, this.id)
          this.selectedSection.prices.splice(index, 1)
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Foreign error
        if (data.error === 'Foreign') {
          this.$message.error('Ingresso não pode ser removido, pois já foi utilizado!', { duration: 3000 })
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async editPrice (price, index) {
      const realPrice = this.withSection ? this.selectedSection.prices[index] : this.prices[index]
      if (realPrice.change) {
        this.loading = true
        try {
          await updatePrice(
            price.id,
            this.id,
            price.name,
            price.value,
            price.sell,
            price.active,
            price.ticketDesc
          )
          realPrice.change = !realPrice.change
          this.loading = false
        } catch (error) {
          this.loading = false
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = ['prices']
          } else if (data.error === 'Foreign') {
            this.$message.error('Ingresso não pode ser alterado, pois já foi utilizado!', { duration: 3000 })
            this.prices[index].value = this.oldPrice
          } else {
            logger.error(error, this)
          }
          realPrice.change = !realPrice.change
        }
      } else {
        this.oldPrice = realPrice.value
        realPrice.change = !realPrice.change
      }
    },
    async saveShow () {
      try {
        if (this.loading) return false
        this.error = []
        if (!this.withoutStage && this.withSection) {
          this.sections.map(x => x.prices).forEach(x => {
            const containZero = []
            x.forEach(y => {
              // watching if there is atleast one price with value different from 0
              if (y.value === 0) containZero.push(true)
              else containZero.push(false)
            })
            if (containZero.filter(x => !x).length === 0) {
              this.error.push('prices')
              return false
            }
          })

          // if section has no ticket price
          if (this.sections.map(x => x.prices).find(x => x.length === 0)) {
            this.error.push('prices')
            return false
          }
        }

        if (!this.image && !this.imageFile) this.error.push('image')
        if (this.error.length > 0) return false
        this.loading = true
        // Add producer
        if (this.addProducer) {
          this.producer = await createProducer(this.producerName, this.producerEmail)
        }
        if (this.showId) {
          // Update show
          if (this.dates.find(date => !date.hour)) {
            this.error.push('dates')
            this.loading = false
            return false
          }
          const show = await updateShow(
            this.showId,
            this.showName,
            this.showTypes.includes(this.showType) ? this.showType : null,
            this.producer ? this.producer.id : null,
            this.showDuration,
            this.showCensor,
            this.showDescription,
            this.imageFile,
            this.showCensorFollowed,
            this.showOnline,
            this.showLive,
            this.showLiveURL,
            this.showcase,
            this.privateShow
          )
          this.showId = show.id
          if (this.dates[0].id) await this.updateShowDate()
          else this.createDates()
        } else {
          // Create show
          const show = await createShow(
            this.showName,
            this.showTypes.includes(this.showType) ? this.showType : null,
            this.producer ? this.producer.id : null,
            this.showDuration,
            this.showCensor,
            this.showDescription,
            this.imageFile,
            this.showCensorFollowed,
            this.showOnline,
            this.showLive,
            this.showLiveURL,
            this.showcase,
            this.privateShow
          )
          this.showId = show.id
          await this.createDates()
          if (this.showOnline && !this.showLive) this.uploadVideo()
        }
        if (this.id === 'new') this.page = 5
        else this.$router.push('/event')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          if (data.fields.indexOf('name') > -1) this.page = 2
          else if (data.fields.indexOf('type') > -1) this.page = 2
          else if (data.fields.indexOf('producer') > -1) this.page = 2
          else if (data.fields.indexOf('duration') > -1) this.page = 2
          else if (data.fields.indexOf('censor') > -1) this.page = 2
          else if (data.fields.indexOf('description') > -1) this.page = 3
          else if (data.fields.indexOf('producerName') > -1) this.page = 2
          else if (data.fields.indexOf('producerEmail') > -1) this.page = 2
          else if (data.fields.indexOf('producer-exists') > -1) this.page = 2
          else this.page = 4
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async getShow (id) {
      this.loading = true
      try {
        const show = await getShow(id)
        this.showId = show.id
        this.showName = show.name
        this.showType = show.type
        this.producer = this.producers.find(x => x.id === show.producer)
        this.showDuration = show.duration
        this.showCensor = show.censor
        this.showDescription = show.description
        this.showOnline = show.online
        this.showLive = show.live || false
        this.showLiveURL = show.liveUrl
        this.image = show.images[0]
        // Get previous show prices
        const prices = await getPreviousPrice(id)
        if (prices.length > 0) {
          if (prices[0].section !== null && prices[0].section !== '1') {
            this.withSection = true
            this.sections.forEach(x => {
              x.prices = prices.filter(y => y.section === x.name).map(y => {
                let amount = 0
                if (String(y.ticketType).toUpperCase().startsWith('MEIA')) amount = Math.ceil((this.business.capacity * 0.4) / this.sections.length)
                else amount = null
                return {
                  name: y.ticketType,
                  sell: y.sell,
                  value: y.price,
                  percentage: this.ticketTypes.find(z => z.name === y.ticketType) ? this.ticketTypes.find(z => z.name === y.ticketType).percentage : 0,
                  special: y.special ? y.special : false,
                  order: y.order || 0,
                  amount,
                  active: x.active,
                  ticketDesc: y.ticketDesc
                }
              })
            })
          } else {
            this.prices = prices.map(x => {
              x.active = true
            })
          }
          this.prices = prices.map(x => {
            let amount = 0
            if (String(x.ticketType).toUpperCase().startsWith('MEIA')) amount = Math.ceil(this.business.capacity * 0.4)
            else amount = this.business.capacity
            return {
              name: x.ticketType,
              sell: x.sell,
              value: x.price,
              percentage: this.ticketTypes.find(y => y.name === x.ticketType) ? this.ticketTypes.find(y => y.name === x.ticketType).percentage : 0,
              special: x.special ? x.special : false,
              order: x.order || 0,
              amount,
              active: x.active,
              ticketDesc: x.ticketDesc
            }
          })
        }
        // Show upload
        if (show.showUpload) this.showUpload = await getUpload(show.showUpload)
        this.page = 2
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
    },
    async createDates () {
      try {
        this.loading = true
        this.error = []
        const installments = []
        for (let i = 0; i < this.numberInstallments; i++) installments.push(i)
        await createDate(
          this.showId,
          this.showOnline && !this.showLive ? [`${this.dateDay} 23:59:59`] : this.dates.map(x => x.day ? (`${x.day} ${x.hour}:00`) : null),
          this.dateSaleDate ? new Date(`${this.dateSale} 00:00:00`) : Number(this.dateSale),
          this.dateLocalSale,
          this.showOnline && !this.showLive ? 0 : this.dateHourCloseSale,
          this.showOnline ? 1 : this.dateMaxTicketUser,
          this.showOnline ? [{
            section: 1,
            ticketType: 'Online',
            price: this.priceValue,
            sell: true,
            special: false,
            order: 0,
            amount: 0,
            active: true
          }] : this.withSection ? this.sections : this.prices.map((x, i) => ({
            section: 1,
            ticketType: x.name,
            price: x.value,
            sell: x.sell,
            special: x.special,
            order: i,
            amount: x.amount,
            active: x.active,
            ticketDesc: x.ticketDesc
          })),
          this.withoutStage ? false : this.booking,
          this.withoutStage,
          this.clientInterest,
          this.installments.sort((a, b) => Number(a) - Number(b)),
          this.distanceRule,
          this.withSection
        )
        this.$router.push('/event')
        // if (this.showOnline && !this.showLive) this.$store.dispatch('openUpload', this.showId)
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          if (data.fields.indexOf('date') > -1) this.page = 5
          else if (data.fields.indexOf('dateSale') > -1) this.page = 6
          else if (data.fields.indexOf('hourCloseSale') > -1) this.page = 6
          else if (data.fields.indexOf('maxTicketUser') > -1) this.page = 6
          else if (data.fields.indexOf('prices') > -1) this.page = 7
          else this.page = 5
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async updateShowDate () {
      try {
        this.error = []
        const installments = []
        for (let i = 1; i <= this.installments.length; i++) installments.push(i)

        let dates = []
        if (this.showOnline && !this.showLive) dates = [`${this.dateDay} 23:59:59`]
        else {
          dates = this.dates.map(x => ({
            id: x.id,
            date: x.day ? (`${x.day} ${x.hour}:00`) : null
          }))
        }

        await updateDate(
          this.showId,
          dates,
          this.dateSaleDate ? new Date(`${this.dateSale} 00:00:00`) : Number(this.dateSale),
          this.dateLocalSale,
          this.showOnline && !this.showLive ? 0 : this.dateHourCloseSale,
          this.showOnline ? 1 : this.dateMaxTicketUser,
          this.withoutStage,
          installments,
          this.withSection,
          this.distanceRule,
          this.withoutStage ? false : this.booking,
          this.clientInterest,
          this.id
        )
        this.$router.push('/event')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          if (data.fields.indexOf('date') > -1) this.page = 5
          else if (data.fields.indexOf('dateSale') > -1) this.page = 6
          else if (data.fields.indexOf('hourCloseSale') > -1) this.page = 6
          else if (data.fields.indexOf('maxTicketUser') > -1) this.page = 6
          else if (data.fields.indexOf('prices') > -1) this.page = 7
          else this.page = 5
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
      this.loading = false
    },
    async updatePriceAmount () {
      this.loading = true
      try {
        await updatePriceAmount(this.id, this.prices.map(x => ({ id: x.id, amount: x.amount })))
        this.$router.push('/event')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = ['prices']
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    changeImage (file) {
      const maxWidth = 1000
      const maxHeight = 400
      const reader = new FileReader()
      reader.onload = e => {
        const img = new Image()
        const self = this
        img.onload = function () {
          let width = this.width
          let height = this.height
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width
              width = maxWidth
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height
              height = maxHeight
            }
          }
          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(img, 0, 0, width, height)
          const dataUrl = canvas.toDataURL('image/jpeg', 1)
          self.image = dataUrl
          const binStr = atob(dataUrl.split(',')[1])
          const arr = new Uint8Array(binStr.length).map((x, i) => binStr.charCodeAt(i))
          self.imageFile = new Blob([arr], { type: 'image/jpeg' })
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    uploadVideo () {
      this.$router.push('/event')
      this.$store.dispatch('openUpload', this.showId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.lock-btn {
  background-color: #fff !important;
  color: #999 !important;
  border: 1px solid #999 !important;
  box-shadow: 0 0 3px #999 !important;
}
.lock-btn:hover {
  background-color: #fff;
  i {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
}
.unlock-btn {
  background-color: #ffff !important;
  color: #560070 !important;
  border: 1px solid #560070 !important;
}
.content-lote {
  border: 1px solid #8900b3;
  border-radius: 20px;
  padding-bottom: 10px;
}
.disableprice {
  text-decoration: line-through;
}
.hasTicketDesc {
  color: #8900b3;
}
.auto-list {
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 1px 1px 5px -1px rgba(0,0,0,0.2);
  position: absolute;
  overflow-x: hidden;
  max-height: 0;
  visibility: hidden;
  transition: max-height 0.8s;
  z-index: 9;
  &.show {
    max-height: 250px;
    overflow-x: scroll;
    visibility: visible;
  }
}
.auto-list-item {
  padding: 8px 10px;
  font-size: 1em;
  border-bottom: 1px dashed #ddd;
  cursor: pointer;
  &:hover {
    background-color: rgba(86, 0, 112, 0.1);
  }
}
.online-selector {
  height: 73px;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}
.installments-footer {
  cursor: pointer;
  color: #b6b6b6;
  .fees { width: 37px; }
  border-collapse: collapse;
  td {
    text-align: center;
    border: 1px solid #e9e9e9;
    &.active {
      background-color: #e5e5e5;
      border-color: #d8d8d8;
      color: #0c0c0c;
    }
  }
  .number {
    width: 26px;
    height: 40px;
  }
}
.installments-table {
  cursor: pointer;
  color: #b6b6b6;
  .fees { width: 37px; }
  border-collapse: collapse;
  td {
    text-align: center;
    border: 1px solid #e9e9e9;
    &.active {
      background-color: #e5e5e5;
      border-color: #d8d8d8;
      color: #0c0c0c;
    }
  }
  tfoot {
    color: #929292;
    font-weight: 700;
    td {
      border: none;
    }
  }
  .number {
    width: 26px;
    height: 40px;
  }
}
.columns {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  max-width: 100%;
  flex-wrap: wrap;
  .divider {
    width: 2.5px;
    height: 100%;
    background: #e9e9e9;
  }
  .column {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-grow: 1;
    // width: calc(100% / 3);
    flex-grow: 1;
    .form-group {
      width: calc(100% - 20px);
    }
  }
}
.show-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #e8e8e8;
  color: #bcbcbc;
  border-radius: 5px;
  width: calc(100% - 8px);
  height: 140px;
  overflow: hidden;
  input { display: none; }
  img {
    width: 100%;
    height: 100%;
    max-width: 300px;
    max-height: 140px;
    object-fit: cover;
    cursor: pointer;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  &.grow { .form-group { flex-grow: 1; } }
  &.justify-end { justify-content: flex-end; }
}
.align-end {
  align-self: flex-end;
}
/deep/ .selector {
  background-color: #cccccc;
  color: #595959;
  font-size: 0.8em;
  padding: 2.5px;
  max-width: 300px;
  .selector-option {
    color: #595959;
    padding: 7px;
  }
}
$width-large: 350px;
.min-number {
  &:after {
    content: 'min';
  }
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
}
.form-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px 10px;
  &.large { width: 350px; }
  &.medium { width: 250px; }
  &.small { width: 150px; }
}
.form {
  max-width: 1115px;
  width: 100%;
}
.table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px 10px;
    font-weight: 400;
  }

  th {
    background-color: #fff;
    color: $primary-color;
    border-bottom: 2px solid $primary-color;
    font-weight: 500;
  }

  tr {
    font-size: 1em;
    color: #555;

    &:nth-child(2n+1) {
      background-color: #e5e5e5;
    }
  }
}

.or-show {
  text-align: center;
  color: $primary-color;
  font-weight: bold;
  margin-bottom: 15px;
}

.show-image-container {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
  height: 160px;
  margin-bottom: 10px;

  input {
    display: none;
  }

  .show-image {
    flex-grow: 1;

    &:hover {
      i {
        border: 3px solid #999;
      }
      img {
        filter: grayscale(50%);
      }
    }

    i {
      color: #999;
      font-size: 50px;
      height: 100%;
      max-width: 338px;
      max-height: 138px;
      margin: 0 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 3px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
    }

    img {
      width: 100%;
      height: 100%;
      max-width: 338px;
      max-height: 138px;
      margin: 0 5px;
      object-fit: cover;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.description-header {
  display: flex;
  align-items: center;
  label {
    flex-grow: 1;
  }
  i {
    font-size: 18px;
    padding: 5px;
    cursor: pointer;
    &:hover {
      animation-name: ticket-form-button;
      animation-timing-function: ease-in-out;
      animation-duration: 1s;
      animation-iteration-count: 3;
    }
  }
}

.installments {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
  .installment {
    flex-shrink: 0;
    width: 50px;
    text-align: center;
    border: 1px solid #bbb;
    color: #bbb;
    font-size: 0.9em;
    border-radius: 5px;
    padding: 2px 0;
    margin: 2px;
    cursor: pointer;
    &.active {
      color: $primary-color;
      border-color: $primary-color;
    }
  }
}

.btn-bordero {
  right: 155px;
  color: $primary-color;
  border: 1px solid $primary-color;
  border-radius: 100px;
  box-shadow: 0 0 3px $primary-color;
  background: #fff;
}
</style>

<style lang="scss">
.lote-event {
    color: #fff;
    border: none;
    border-radius: 100px;
    background-image: -webkit-gradient(linear, left top, right bottom, from(#BDBDBD), to(#BDBDBD));
    background-image: linear-gradient(to bottom right, #BDBDBD, #BDBDBD);
    font-size: 1em;
    font-weight: 400;
    width: 100px;
    height: 40px;
    padding: 0 15px;
    cursor: pointer;
    margin-right: 10px;
    float: left;
    margin-bottom: 10px;
}
.lote_active {
  background-image: -webkit-gradient(linear, left top, right bottom, from(#560070), to(#8900b3));
  background-image: linear-gradient(to bottom right, #560070, #8900b3);
}
.fullscreen {
  background-color: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.3);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  form {
    max-width: 750px;
    height: calc(100% - 100px);
    margin: 0 auto;
  }
  .actions {
    max-width: 750px;
    margin: 0 auto;
  }
  .quill-editor {
    height: calc(100% - 80px) !important;
  }
  .ql-editor {
    max-height: 100% !important;
  }
}

.quill-editor {
  // height: 350px;
  margin-top: 5px;
}
.ql-editor{
  min-height: 200px;
  max-height: 300px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  img {
    max-width: 100%;
    height: auto;
  }
}
.ql-picker-item[data-value='12px']::before, .ql-picker-label[data-value='12px']::before {
  content: 'Pequeno' !important;
  font-size: 12px;
}
.ql-picker-item[data-value='16px']::before, .ql-picker-label[data-value='16px']::before {
  content: "Medio" !important;
  font-size: 16px;
}
.ql-picker-item[data-value='20px']::before, .ql-picker-label[data-value='20px']::before {
  content: 'Grande' !important;
  font-size: 20px;
}
</style>
